import { BetaValues, BetaResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Stock move (%) = Market move (%) * Beta
export function calculateBetaMove(values: BetaValues, t?: ToolsTranslations['beta']): BetaResult {
  const { marketMovePercent, beta } = values;
  if (beta < 0) return { movePercent: null, isValid: false, message: t?.invalid.beta };

  const movePercent = Math.round((marketMovePercent * beta) * 100) / 100; // 2 decimals
  if (!isFinite(movePercent)) return { movePercent: null, isValid: false, message: t?.invalid.generic };
  return { movePercent, isValid: true };
}


